import React from 'react';
import { useLocation } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';

//Hidden link for keyboard users that jumps the user to the beginning of the main content area
const SkipNavLink = (props) => {
    const { children } = props;
    const location = useLocation();
    const path = location.pathname;

    return (
        <HashLink to={`${path}#main-content`} className="visually-hidden skip-navigation">
            {children}
        </HashLink>
    );
}

export default SkipNavLink;